import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, MenuItem, Select, FormControl, InputLabel } from '@mui/material';
import { useForm, Controller } from 'react-hook-form';

export default function DialogInviaMail({ open, onClose, onConfirm }) {
    const { control, handleSubmit } = useForm({
        defaultValues: {
            firma: ''
        }
    });

    const onSubmit = (data) => {
        onConfirm(data.firma);
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle>Invia mail del contratto</DialogTitle>
            <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <FormControl fullWidth margin="normal">
                        <InputLabel id="firma-select-label">Seleziona firma</InputLabel>
                        <Controller
                            name="firma"
                            control={control}
                            required
                            render={({ field }) => (
                                <Select
                                    labelId="firma-select-label"
                                    id="firma-select"
                                    label="Seleziona Firma"
                                    {...field}
                                >
                                    <MenuItem value="SENZA_FIRMA">INVIA SENZA FIRMA</MenuItem>
                                    <MenuItem value="DAVIDE">INVIA CON FIRMA DI DAVIDE</MenuItem>
                                    <MenuItem value="GIANFRANCO">INVIA CON FIRMA DI GIANFRANCO</MenuItem>
                                </Select>
                            )}
                        />
                    </FormControl>
                </form>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Annulla
                </Button>
                <Button onClick={handleSubmit(onSubmit)} color="primary" variant="contained">
                    Invia
                </Button>
            </DialogActions>
        </Dialog>
    );
}